export const SRI_LANKA_PROVINCES = [
  'Western',
  'Central',
  'Southern',
  'Northern',
  'Eastern',
  'North Western',
  'North Central',
  'Uva',
  'Sabaragamuwa'
];

export const SRI_LANKA_DISTRICTS_BY_PROVINCE = {
  'Western': ['Colombo', 'Gampaha', 'Kalutara'],
  'Central': ['Kandy', 'Matale', 'Nuwara Eliya'],
  'Southern': ['Galle', 'Matara', 'Hambantota'],
  'Northern': ['Jaffna', 'Kilinochchi', 'Mannar', 'Vavuniya', 'Mullaitivu'],
  'Eastern': ['Batticaloa', 'Ampara', 'Trincomalee'],
  'North Western': ['Kurunegala', 'Puttalam'],
  'North Central': ['Anuradhapura', 'Polonnaruwa'],
  'Uva': ['Badulla', 'Monaragala'],
  'Sabaragamuwa': ['Ratnapura', 'Kegalle']
};

export const ALL_SRI_LANKA_DISTRICTS = Object.values(SRI_LANKA_DISTRICTS_BY_PROVINCE).flat().sort();

export const HIGHEST_EDUCATION_OPTIONS = [
  'G.C.E. O/L',
  'G.C.E. A/L',
  'Diploma',
  'Higher Diploma',
  'Bachelor\'s Degree',
  'Postgraduate Diploma / Master\'s',
  'Doctorate (PhD)',
  'Professional Qualification (CIMA / ACCA / CA / CIM / SLIM)',
  'Other'
];

export const AL_STREAM_OPTIONS = [
  'Commerce',
  'Physical Science (Maths)',
  'Biological Science (Bio)',
  'Technology (Engineering / Bio / ICT)',
  'Arts',
  'Other'
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  { label: 'Employed (Full-Time / Part-Time)', value: 'employed' },
  { label: 'Self-Employed / Freelancer', value: 'self_employed' },
  { label: 'Business Owner / Entrepreneur', value: 'business_owner' },
  { label: 'Student', value: 'student' },
  { label: 'Unemployed / Seeking Employment', value: 'unemployed' },
  { label: 'Other', value: 'other' }
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  'Full-Time',
  'Part-Time',
  'Contract',
  'Freelance / Consultant',
  'Remote',
  'Internship'
];

export const YEARS_OF_EXPERIENCE_OPTIONS = [
  'Fresh Graduate / No Experience',
  'Less than 1 Year',
  '1 – 3 Years',
  '3 – 5 Years',
  '5 – 10 Years',
  'More than 10 Years'
];

export const PROFESSIONAL_INTEREST_AREAS = [
  'Accounting & Finance',
  'Excel & Data Analytics',
  'Power BI',
  'QuickBooks',
  'Taxation',
  'Auditing',
  'Management',
  'Human Resources (HR)',
  'Logistics & Supply Chain',
  'Import & Export',
  'Artificial Intelligence & Machine Learning',
  'Digital Marketing',
  'Graphic Design',
  'Professional Qualifications',
  'Software Development & Web Design',
  'Other'
];

export const LEARNING_MODE_OPTIONS = [
  { label: 'Online – Live Zoom Sessions', value: 'online_zoom' },
  { label: 'Physical – In-Class Lectures', value: 'physical' },
  { label: 'Hybrid – Both Online & Physical', value: 'hybrid' }
];

export const PREFERRED_LANGUAGE_OPTIONS = [
  { label: 'Sinhala', value: 'sinhala' },
  { label: 'English', value: 'english' },
  { label: 'Bilingual (Sinhala & English)', value: 'sinhala_english' }
];

export const DOCUMENT_TYPE_LABELS = {
  nic_front: 'National Identity Card (NIC) – Front Side',
  nic_back: 'National Identity Card (NIC) – Back Side',
  passport: 'Passport (Bio Page)',
  passport_photo: 'Passport-Size Formal Photograph',
  educational_cert: 'Highest Educational Qualification Certificate',
  professional_cert: 'Professional Qualification Certificate',
  other: 'Other Supporting Document'
};
